import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { CustomListDropdown } from 'src/app/interfaces/custom-list/custom-list-dropdown.interface';
import { ItemFilterModel } from 'src/app/models/filters/item-filter.model';
import { environment } from 'src/environments/environment';
import { EnterpriseModel } from './../../models/management/enterprise.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';

@Injectable({
  providedIn: 'root'
})
export class EnterpriseService {

  constructor(private _httpClient: HttpClient) { }

  createEnterprise(enterprisetModel: EnterpriseModel): Observable<EnterpriseModel> {
    return this._httpClient.post<EnterpriseModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.enterprise.CreateEnterprise}`,
      enterprisetModel);
  }

  deleteEnterprise(enterpriseId: number): Observable<EnterpriseModel> {
    return this._httpClient.delete<EnterpriseModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.enterprise.DeleteEnterprise}/${enterpriseId}`);
  }

  getAllEnterprisesForSelectAsync(): Observable<Array<CustomListDropdown>> {
    return this._httpClient.get<Array<CustomListDropdown>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.enterprise.GetAllEnterprisesForSelectAsync}`,);
  }

  getAllEnterprisesWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.enterprise.GetAllEnterprisesWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  getAllTecnologyProvidersForSelect(): Observable<Array<CustomListDropdown>> {
    return this._httpClient.get<Array<CustomListDropdown>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.enterprise.GetAllTecnologyProvidersForSelectAsync}`,);
  }

  getAllTypeDocumentsForSelect(): Observable<Array<CustomListDropdown>> {
    return this._httpClient.get<Array<CustomListDropdown>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.enterprise.GetAllTypeDocumentsForSelectAsync}`,);
  }

  getAllTypePersonsForSelect(): Observable<Array<CustomListDropdown>> {
    return this._httpClient.get<Array<CustomListDropdown>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.enterprise.GetAllTypePersonsForSelectAsync}`,);
  }

  getColumnsForGeneralConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.enterprise.GetColumnsForGeneralConsultationAsync}`);
  }

  getEnterprisesByBranchIdForSelect(branchId: number): Observable<Array<CustomListDropdown>> {
    return this._httpClient.get<Array<CustomListDropdown>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.enterprise.GetEnterprisesByBranchIdForSelect}/${branchId}`,);
  }

  getDigitVerification(document: string): Observable<number> {
    const itemFilterResponse = new ItemFilterModel("document", null, null, "");
    itemFilterResponse.wildcard = document;
    return this._httpClient.post<number>(`${environment.apiCervinoBackend}${enpointCervinoWeb.enterprise.GetDigitVerification}`, itemFilterResponse);
  }

  getEnterpriseByBranchId(branchId: number): Observable<Array<EnterpriseModel>> {
    return this._httpClient.get<Array<EnterpriseModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.enterprise.GetEnterpriseByBranchId}/${branchId}`);
  }

  getEnterpriseByCode(branchId: number, code: number): Observable<EnterpriseModel> {
    return this._httpClient.get<EnterpriseModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.enterprise.GetEnterpriseByCode}/${branchId}/${code}`)
  }

  getEnterpriseById(enterpriseId: number): Observable<EnterpriseModel> {
    return this._httpClient.get<EnterpriseModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.enterprise.GetEnterpriseById}/${enterpriseId}`);
  }

  getEnterpriseLogoAsync(enterpriseLogo: string): Observable<Blob | null> {
    const params = new HttpParams().set('enterpriseLogo', enterpriseLogo)
    return this._httpClient.get<Blob>(`${environment.apiCervinoBackend}${enpointCervinoWeb.enterprise.GetEnterpriseLogoAsync}`,
      { params: params, responseType: "blob" as "json" }
    );
  }

  getFirstEnterpriseByBranch(branchId: number): Observable<EnterpriseModel> {
    return this._httpClient.get<EnterpriseModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.enterprise.GetFirstEnterpriseByBranch}/${branchId}`);
  }

  getFirstEnterpriseByKeysAsync(branchId: number): Observable<EnterpriseModel> {
    const params = new HttpParams().set('branchId', branchId);
    return this._httpClient.get<EnterpriseModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.enterprise.GetFirstEnterpriseByKeysAsync}`,
      { params: params }
    );
  }

  getLastEnterpriseByKeysAsync(branchId: number): Observable<EnterpriseModel> {
    const params = new HttpParams().set('branchId', branchId);
    return this._httpClient.get<EnterpriseModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.enterprise.GetLastEnterpriseByKeysAsync}`,
      { params: params }
    );
  }

  getLogo(enterprisetModel: EnterpriseModel): Observable<Blob | null> {
    return this._httpClient.post<Blob>(`${environment.apiCervinoBackend}${enpointCervinoWeb.enterprise.GetLogo}`,
      enterprisetModel, { responseType: "blob" as "json" });
  }

  getLogoFooter(enterprisetModel: EnterpriseModel): Observable<Blob | null> {
    return this._httpClient.post<Blob>(`${environment.apiCervinoBackend}${enpointCervinoWeb.enterprise.GetLogoFooter}`,
      enterprisetModel, { responseType: "blob" as "json" });
  }

  getNextEnterpriseByKeysAsync(branchId: number, code: number): Observable<EnterpriseModel> {
    const params = new HttpParams().set('branchId', branchId).set('code', code);
    return this._httpClient.get<EnterpriseModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.enterprise.GetNextEnterpriseByKeysAsync}`,
      { params: params }
    );
  }

  getPreviusEnterpriseByKeysAsync(branchId: number, code: number): Observable<EnterpriseModel> {
    const params = new HttpParams().set('branchId', branchId).set('code', code);
    return this._httpClient.get<EnterpriseModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.enterprise.GetPreviusEnterpriseByKeysAsync}`,
      { params: params }
    );
  }

  getSignature(enterprisetModel: EnterpriseModel): Observable<Blob | null> {
    return this._httpClient.post<Blob>(`${environment.apiCervinoBackend}${enpointCervinoWeb.enterprise.GetSignature}`,
      enterprisetModel, { responseType: "blob" as "json" });
  }

  setActiveEnterprise(enterpriseId: number): Observable<EnterpriseModel> {
    return this._httpClient.put<EnterpriseModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.enterprise.SetActiveEnterprise}/${enterpriseId}`,
      null);
  }

  updateEnterprise(enterprisetModel: EnterpriseModel): Observable<EnterpriseModel> {
    return this._httpClient.put<EnterpriseModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.enterprise.UpdateEnterprise}`,
      enterprisetModel);
  }

  getImageUrl(fullPath: string): Observable<Blob> {
    const params = new HttpParams().set('fullPath', fullPath);
    return this._httpClient.get(`${environment.apiCervinoBackend}${enpointCervinoWeb.enterprise.GetImagesAsync}`,
      { responseType: 'blob', params });
  }

  deleteImage(enterpriseId: number, imageNumber: number): Observable<EnterpriseModel> {
    return this._httpClient.post<EnterpriseModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.enterprise.DeleteImagesAsync}/${enterpriseId}/${imageNumber}`,
      null);
  }

  attachImage(enterpriseId: number, imageNumber: number, file: FormData): Observable<EnterpriseModel> {
    return this._httpClient.post<EnterpriseModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.enterprise.AttachImagesAsync}/${enterpriseId}/${imageNumber}`,
      file);
  }
}
